<div class="snow-overlay">
  @if (showTutorial() && !isMobileDevice()) {
    <div class="controls-indicator" animate.leave="leaving" animate.enter="enter-animation">
      <img class="controls-indicator__image" src="/assets/christmas/arrowkeys-graphic.svg" alt="" />
    </div>
  }
  <canvas #canvas></canvas>

  @if (debug()) {
    <div class="controls">
      <button class="debug-toggle" (click)="toggleDebug()">{{ showDebug() ? 'Hide' : 'Show' }} Debug</button>
      <button class="debug-toggle" (click)="toggleStats()">{{ showStats() ? 'Hide' : 'Show' }} Stats</button>
    </div>
  }
</div>
